import PendoIcon from '../../icon/pendo-icon.vue.js';

var script = {
  name: 'PendoCollapseItemCard',
  components: {
    PendoIcon
  },
  inject: ['$collapse'],
  props: {
    title: {
      type: String,
      required: true
    },
    allowCollapse: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    if (this.$collapse.$el.parentNode.classList[0] === 'pendo-card__body') {
      this.$collapse.$el.parentNode.style.padding = 0;
    }
  }
};

export { script as default };
//# sourceMappingURL=card-trigger.vue2.js.map
